<ng-template #template>
  <soft-resource-container [resource]="resource()">
    <ng-content></ng-content>
  </soft-resource-container>
</ng-template>
